import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import axios from "../../../../global/unApi";
import Authorize from "../../../../global/Authorize";
import noData from "../../../Assets/img/noData.png";
import Skeleton from "react-loading-skeleton";

const mapStateToProps = ({ dispatch, user }) => ({
  dispatch,
  user,
});

class ClassAtt extends Component {
  state = {
    dateToday: new Date(),
    dateValue: null,

    date: new Date(),
    attendence: [],
    loading: true,
  };

  componentDidMount = () => {
    var datee = `${this.state.dateToday.getFullYear()}-${
      (this.state.dateToday.getMonth() + 1 < 10 ? "0" : "") +
      (this.state.dateToday.getMonth() + 1)
    }-${
      (this.state.dateToday.getDate() < 10 ? "0" : "") +
      this.state.dateToday.getDate()
    }`;

    this.setState({
      dateValue: `${this.state.dateToday.getFullYear()}-${
        this.state.dateToday.getMonth > 9 ? "" : "0"
      }${
        this.state.dateToday.getMonth() + 1
      }-${this.state.dateToday.getDate()}`,
    });

    this.fetchAttendence({
      date: datee,
      school: this.props.user.user.school.id,
      session: this.props.user.session.id,
    });
  };
  fetchAttendence = (params = {}) => {
    axios
      .get("/api/todaystudentclasswiseattendencecount", {
        params: { ...params },
      })
      .then((res) => {
        this.setState({ attendence: res.data, loading: false });
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  handleDateChange = (e) => {
    this.setState({ dateValue: e.target.value, loading: true });

    this.fetchAttendence({
      date: e.target.value,
      session: this.props.user.session.id,
      school: this.props.user.user.school.id,
    });
  };

  render() {
    const { dateToday, attendence } = this.state;
    let { assignedClassList } = this.props;

    let unrestrictedRoles = ["IS_SUPERADMIN", "IS_PRINCIPAL", "IS_ACCOUNTANT"];

    let assignedClassAttendance = unrestrictedRoles?.includes(
      this.props.user.role.name
    )
      ? attendence
      : attendence?.filter((each) => {
          return assignedClassList
            ?.map((item) => item.class_name)
            ?.includes(each.student_info__student_class__class_name);
        });
    return (
      <Authorize roles={["IS_TEACHER", "IS_PRINCIPAL"]} redirect to="/">
        <div className="input-group input-group-sm my-2">
          <input
            className="form-control th-input-primary th-12"
            type="date"
            value={this.state.dateValue}
            onChange={this.handleDateChange}
            max={`${dateToday.getFullYear()}-${
              dateToday.getMonth > 9 ? "" : "0"
            }${dateToday.getMonth() + 1}-${dateToday.getDate()}`}
          />
        </div>

        {assignedClassAttendance?.length !== 0 && this.state.loading ? null : (
          <table class="table table-striped w-100 th-12">
            <thead>
              <tr>
                <td className="th-medium">Class</td>
                {/* <td className="th-medium">Section</td> */}
                <td className="th-medium">P</td>
                <td className="th-medium">A</td>
                <td className="th-medium">HD</td>
                <td className="th-medium">Late</td>
                <td className="th-medium">Total</td>
              </tr>
            </thead>

            <tbody>
              {assignedClassAttendance?.map((item, index) => {
                return (
                  <tr>
                    <td>
                      {item.student_info__student_class__class_name}-
                      {item.section_name}
                    </td>
                    {/* <td>{item.section_name}</td> */}
                    <td>{item.present_attendence_count}</td>
                    <td>{item.absent_attendence_count}</td>
                    <td>{item.half_day_attendence_count}</td>
                    <td>{item.late_attendence_count}</td>
                    <td>{item.total_count}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
        {this.state.loading ? (
          <div className="w-100">
            <Skeleton height={24} count={6} />
          </div>
        ) : null}

        {this.state.attendence?.length === 0 && this.state.loading === false ? (
          <div className="px-5 py-5">
            <img className="w-100 mt-5" src={noData} alt="No Data Found" />
            <p className="text-center th-14 th-bold mt-5">
              No Attendance Data Found!
            </p>
          </div>
        ) : null}
        <div style={{ height: "25vh" }}></div>
      </Authorize>
    );
  }
}
export default withRouter(connect(mapStateToProps)(ClassAtt));
